import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class MemberActiveUsersTable extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			users: [],
		};
	
		this.createUserRow = this.createUserRow.bind(this);
		this.editUser = this.editUser.bind(this);
	}

	componentDidMount() {
		//console.log('UsersTable: componentDidMount');
		this.loadUsers();
	}

	loadUsers() {
		var _this = this;
		Axios.get('/api/users/activeMembers').then(function(response) {
			_this.setState({
				users: response.data
			});
		});
	}

	render() {
		//console.log('MemberActiveUsersTable: render');
		return (
			<div className="table-responsive">
				<table className="table table-striped table-hover table-sm">
				<tbody>
					<tr>
						<th></th>
						<th></th>
						<th>ids (user._id, auth0_user_id)</th>
						<th>Noms (auth0, user)</th>
						<th>Joueur Associé</th>
						<th>Expiration</th>
						<th>Dernière connection</th>
					</tr>
					{this.state.users.map(this.createUserRow)}
				</tbody>
				</table>
			</div>
		);
	}

	createUserRow(user, userIdx) {
		return (
			<tr key={user._id}>
				<td><input name={'edit.' + user._id} type="button" onClick={this.editUser} value="Éditer"/></td>
				<td><img className="img-stand-token" src={user.profilePicture}/></td>
				<td>{user._id} <br/>
					{user.auth0_user_id}</td>
				<td>{user.auth0_name} <br/>
					{user.name}</td>
				<td>{user.playerName}</td>
				<td>{moment(user.memberDateExpiration).format("YYYY-MM-DD")} <br/>
					{moment(user.memberDateExpiration).format("HH:mm:ss")}</td>
				<td>{moment(user.lastConnectionDate).format("YYYY-MM-DD")} <br/>
					{moment(user.lastConnectionDate).format("HH:mm:ss")}</td>
		   </tr>
		);
	}

	editUser(e) {
		var elemInfo = e.target.name.split(".");
		var userEditId = elemInfo[1];
		const path = '/admsafe/users/' + userEditId;
		this.props.history.push(path);
	}

}

export default MemberActiveUsersTable;
